import { TypedDocumentNode, gql } from '@apollo/client';
import { isFuture } from 'date-fns';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { laptopAndBelow } from '@sorare/core/src/style/mediaQuery';

import { SingleMatchupItem } from 'components/benchObject/SingleMatchupItem';

import { CalendarTooltip } from './CalendarTooltip';
import { UpcomingGames_anyPlayer } from './__generated__/index.graphql';

type Props = {
  anyPlayer: UpcomingGames_anyPlayer;
};

const Root = styled(Horizontal)`
  background-color: var(--current-row-color);
  @media ${laptopAndBelow} {
    display: none;
  }
`;
const MatchupWrapper = styled(Horizontal).attrs({ gap: 0 })`
  min-width: 120px;
  height: var(--triple-unit);
  border-radius: var(--half-unit);
  background: var(--c-nd-50);
  overflow: hidden;
`;

export const UpcomingGames = ({ anyPlayer }: Props) => {
  const upcomingGames =
    anyPlayer.activeClub?.upcomingGames.filter(
      anyGame => anyGame && isFuture(anyGame.date)
    ) || [];
  const featuredGame = upcomingGames[0];
  const hasAGame = !!upcomingGames[0];

  return (
    <Root gap={0.5}>
      {featuredGame && (
        <MatchupWrapper>
          <SingleMatchupItem
            anyGame={featuredGame}
            playerTeamSlug={anyPlayer.activeClub?.slug}
          />
        </MatchupWrapper>
      )}
      <CalendarTooltip anyPlayer={anyPlayer} hasAGame={hasAGame} />
    </Root>
  );
};

UpcomingGames.fragments = {
  anyPlayer: gql`
    fragment UpcomingGames_anyPlayer on AnyPlayerInterface {
      slug
      activeClub {
        slug
        upcomingGames(first: 1) {
          id
          date
          ...SingleMatchupItem_anyGame
        }
      }
      ...CalendarTooltip_anyPlayer
    }
    ${SingleMatchupItem.fragments.anyGame}
    ${CalendarTooltip.fragments.anyPlayer}
  ` as TypedDocumentNode<UpcomingGames_anyPlayer>,
};
